module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_8019.28956d76.png";